<template>
  <div class="charts-page">
    <div class="row topCardGrid">
        <sp-card :valor="totais.demandaCreche" :descricao="$t('graficosEducacao.cardSolicitacoes')" :grid="3" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})" />
        <sp-card :valor="admDireta" :valorProgressBar="admDiretaPercentual" :descricao="$t('graficosEducacao.cardSolicitacoesDireta')" :grid="3" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"></sp-card>
        <sp-card :valor="admIndireta" :valorProgressBar="admIndiretaPercentual" :descricao="$t('graficosEducacao.cardSolicitacoesIndireta')" :grid="3" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"></sp-card>
        <sp-card :valor="parceira" :valorProgressBar="parceiraPercentual" :descricao="$t('graficosEducacao.cardSolicitacoesConveniada')" :grid="3" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"></sp-card>
    </div>
    <div class="row">
        <div class="flex md12 xs12">
            <sp-360-panel class="chart-widget" :title="$t('graficosEducacao.mapTituloDemanda')" :tooltipOptions="topToolTipOptions"
            :footerComplementar="$t('graficosEducacao.mapTituloDemandaRodape')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
                <div class="md12 xs12" style="position: relative;">
                    <div class="row">
                        <div class="flex md6 xs12">
                            <multiselect
                                id="selectSubprefeituras"
                                name="Subprefeituras"
                                :placeholder="$t('graficosEducacao.mapFiltroSubPlaceholder')"
                                :value="selSub"
                                :options="subs"
                                :close-on-select="true"
                                :show-labels="false"
                                @input="updatesub"
                            />
                        </div>
                    </div>
                    <GmapMap
                        id="mapaTransito"
                        ref="gmap"
                        :center="this.center"
                        :zoom="this.zoom"
                        map-type-id="roadmap"
                        style="width: 100%; height: 35rem">
                    </GmapMap>
                    <div id="legenda" class="legenda d-flex justify-content-center"/>
                </div>
            </sp-360-panel>
        </div>
    </div>
     <div class="row" v-show="false">
        <div class="flex md12 xs12 ">
            <sp-360-panel class="grafico-bar-chart-vertical" :title="$t('graficosEducacao.distribuicaoDemandaCreche')" :tooltipOptions="topToolTipOptions">
              <sp360-chart id="hist" :data="histogramChart" type="vertical-bar" :options="histogramChartOption" />
            </sp-360-panel>
        </div>
     </div>

  </div>
</template>

<script>
import CorUtils from '@/utils/CorUtils'
import MethGlob from '@/utils/MetodosGlobais'
import constantes from '@/utils/ConstantesGlobais'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import Overlay from '@/assets/geojson/spoverlay'
import SpCard from '@/components/ui/cards/SP360Card'
import { gmapApi } from 'vue2-google-maps'
import * as d3 from 'd3'
import * as legend from 'd3-svg-legend'
import ChartAnnotation from 'chartjs-plugin-annotation'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Legenda from '@/components/maps/360-maps/Legenda'

export default {
  name: 'transito-dashboard',
  mixins: [Overlay, Legenda],
  components: {
    SpCard,
    Multiselect,
    Sp360Chart,
    Sp360Panel,
  },

  data () {
    return {
      selTipo: '',
      selSub: '',
      tipos: [],
      subs: [],
      dados: {},
      totais: {},
      demandaCreche: [],
      redeCreche: [],
      heatMapData: [],
      tooltipOptions: {
        content: '',
        placement: 'top',
      },
      center: constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_CENTER,
      zoom: constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_ZOOM,
      topToolTipOptions: {
        content: this.$t('graficosEducacao.descricaoInterrogacao'),
        placement: 'bottom',
      },
      heatmap: {},
      filtrado: false,
      pontosCentrais: {},
      histogramChartOption: {},
      histogramChart: {},
      colors: [],
      legenda: d3.select('#legenda'),

    }
  },

  computed: {
    google: gmapApi,

    admDireta: function () {
      return this.redeCreche[0] | 0
    },

    admIndireta: function () {
      return this.redeCreche[1] | 0
    },

    parceira: function () {
      return this.redeCreche[2] | 0
    },

    admDiretaPercentual: function () {
      return this.redeCreche[3] | 0
    },

    admIndiretaPercentual: function () {
      return this.redeCreche[4] | 0
    },

    parceiraPercentual: function () {
      return this.redeCreche[5] | 0
    },
  },

  created () {
    this.$store.dispatch('servicosSME/buscarRedeEnsino', { agrupamento: 'NENHUM' })
      .then((resposta) => {
        this.$gmapApiPromiseLazy().then(() => { // Aguarda a API Assincrona do Gmaps carregar para executar o codigo abaixo.
          this.processarDados(resposta.data)
          this.iniciaGmap(this.heatMapData)
          this.redeCreche = this.calculaCoberturaCreches(resposta.data)
          //{fonte: fonte, data: dataRef}
          this.fonte = resposta.sigla_orgao + '-' + resposta.fonte
          this.dataRef = new Date(resposta.data_referencia_dado).toLocaleDateString('pt-BR')
          this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
          this.sigla = resposta.sigla_orgao
        })
      })
  },
  mounted () {
  },

  methods: {
    rodapeData (d, data) {
      // :footerText="$t('rodape.fonteData', {fonte: 'graficosEducacao.fonte', data: rodapeData(-1)})"
      return MethGlob.rodapeData(d, data)
    },
    updatetipo (value) {
      this.selTipo = value
      this.filtrarmapa()
    },

    updatesub (value) {
      this.selSub = value
      this.filtrarmapa()
    },

    formatarNumero (x) {
      return MethGlob.thousandSeparator(x)
    },

    /**
     *
     * @dados : {Array}
     */
    processarDados (dados) {
      this.totais = {
        unidades: 0,
        demandaCreche: 0,
        unidadesDiretas: 0,
      }

      this.$gmapApiPromiseLazy().then(() => { // Aguarda a API Assincrona do Gmaps carregar para executar o codigo abaixo.
        let arr = []
        dados.forEach(element => {
          if (element.demanda_creche) {
            this.totais.demandaCreche += element.demanda_creche
            arr.push(element.demanda_creche)
            this.heatMapData.push({
              location: new google.maps.LatLng(element.posicao.lat, element.posicao.lng),
              weight: element.demanda_creche,
              sub: element.nome_subprefeitura,
              tipo: element.tipo,
            })
          }
        })

        this.pontosCentrais = MethGlob.calculaPontosCentrais(arr)
        this.totais.unidades = dados.length
        this.dados = dados
        let domain = []
        this.colors = CorUtils.getGradientVector().slice(1)

        // let factor = this.pontosCentrais.uniqDomain.length / this.colors.length
        // for (let index = (this.pontosCentrais.uniqDomain.length); index >= 0; index = (index - factor)) {
        //   domain.push(this.pontosCentrais.uniqDomain[ Math.ceil(index - 1) >= 0 ? Math.ceil(index - 1) : 0 ])
        // }
        // domain.pop()
        // domain = this.calcularDominioLegenda(this.pontosCentrais.uniqDomain, this.pontosCentrais.uniqDomain.length / this.colors.length)
        // this.drawLegenda(d3.select('#legenda'), this.pontosCentrais.uniqDomain, this.colors, 'Escala de Demanda')

        this.populateHistogram()
      })
      // this.tipos = _.orderBy(Object.keys(_.groupBy(dados, 'tipo')));
      this.subs = _.orderBy(Object.keys(_.groupBy(dados, 'nome_subprefeitura')))
    },

    // Recede um Array
    calcularDominioLegenda (dominio, fator) {
      let d = []
      for (let index = (dominio.length); index >= 0; index = (index - fator)) {
        d.push(dominio[ Math.ceil(index - 1) >= 0 ? Math.ceil(index - 1) : 0 ])
      }
      d.pop()
      return d
    },

    calculaCoberturaCreches (dados) {
      let direta = 0
      let indireta = 0
      let conveniada = 0
      let total = 0
      let data = []

      let unidadesDiretas = 0
      let unidadesIndiretas = 0
      let unidadesParceiras = 0

      let demandaDireta = 0
      let demandaIndireta = 0
      let demandaParceira = 0

      dados.forEach(d => {
        switch (d.tipo) {
          case 'CECI':
          case 'CEMEI':
          case 'CEU CEI':
          case 'CCI/CIPS':
          case 'CEI DIRET':
            direta += d.demanda_creche
            unidadesDiretas += 1
            break
          case 'CEI INDIR':
            indireta += d.demanda_creche
            unidadesIndiretas += 1
            break
          case 'CR.P.CONV':
          case 'ESC.PART.':
            conveniada += d.demanda_creche
            unidadesParceiras += 1
            break
          default:
            break
        }
      })
      total = direta + indireta + conveniada
      let dataset = [direta,
        indireta,
        conveniada,
        ...MethGlob.arredondaPorcentagens([(100 * direta / total), (100 * indireta / total), (100 * conveniada / total)], 0),
        total,
      ]

      return dataset
    },

    iniciaGmap (heatMapData) {
      let colorArray = [CorUtils.getCorPorNomeSp360(CorUtils.VERDE_SKOBELOFF_MEDIO), CorUtils.getCorPorNomeSp360(CorUtils.AMARELO_MEDIO), CorUtils.getCorPorNomeSp360(CorUtils.VERMELHO_MEDIO)]
      let heatmapColor = ['rgba(0, 255, 255, 0)', CorUtils.getCorPorNomeSp360(CorUtils.VERDE_SKOBELOFF_MEDIO), CorUtils.getCorPorNomeSp360(CorUtils.AMARELO_MEDIO), CorUtils.getCorPorNomeSp360(CorUtils.VERMELHO_MEDIO)]
      this.center = constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_CENTER
      this.zoom = constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_ZOOM_SME
      this.$refs.gmap.$mapPromise.then((map) => {
        let heatmap = new google.maps.visualization.HeatmapLayer({
          data: heatMapData,
        })
        heatmap.setMap(map)

        heatmap.setOptions({
          dissipating: true,
          maxIntensity: this.pontosCentrais.max,
          radius: 8,
          opacity: 1,
          gradient: heatmapColor,
        })
        map.data.addGeoJson(this.getGeoJsonLayer())
        // Setando o estilo pro Polygon

        map.data.setStyle({
          /* fillColor: 'green', */
          strokeWeight: 0,
        })
        this.heatmap = heatmap
        let colorArray = [CorUtils.getCorPorNomeSp360(CorUtils.VERDE_SKOBELOFF_MEDIO), CorUtils.getCorPorNomeSp360(CorUtils.AMARELO_MEDIO), CorUtils.getCorPorNomeSp360(CorUtils.VERMELHO_MEDIO)]
        this.drawLegendaGradiente(d3.select('#legenda'), CorUtils.getGradientVector(), ['', '', '', '', '', ''], this.pontosCentrais.min, this.pontosCentrais.max, d3.select('#legenda')._groups[0][0].clientWidth, null, this.$t('graficosEducacao.textoEixoLegenda.mapaDemandaCreche'))
        // this.drawLegendaRetangularComGradiente(
        //   d3.select('#legenda'),
        //   this.pontosCentrais,
        //   colorArray,
        //   this.$t('graficosEducacao.textoEixoLegenda.mapaDemandaCreche'))
      })
    },

    filtrarmapa () {
      let filtrados = []
      if (this.selSub && this.selTipo) { // Filtrando pelos DOIS CAMPOS
        filtrados = _.filter(this.heatMapData, (o) => {
          return (o.sub === this.selSub && o.tipo === this.selTipo)
        })
      } else if (this.selSub || this.selTipo) { // Filtrando por UM DOS CAMPOS
        filtrados = _.filter(this.heatMapData, (o) => {
          return (o.sub === this.selSub || o.tipo === this.selTipo)
        })
      } else { // RESET do Filtro
        filtrados = _.orderBy(this.heatMapData, ['weight'], ['asc'])
      }
      this.heatmap.setData(filtrados)
      this.drawLegendaGradiente(d3.select('#legenda'), CorUtils.getGradientVector(), ['', '', '', '', '', ''], 1, _.last(filtrados).weight, 1200, null, this.$t('graficosEducacao.textoEixoLegenda.mapaDemandaCreche'))
    },

    populateHistogram () {
      let dados = _.countBy(this.pontosCentrais.domain, Math.floor)
      let somatorio = _.reduce(this.pontosCentrais.domain, (e, n) => (n += e))
      let labels = []
      let data = []
      let aux = 0
      let groupData = []
      let uLabels = []

      let integral = {
        label: 'Percentual acumulado',
        backgroundColor: CorUtils.setAlpha(CorUtils.getCorPorNomeSp360('cinza-medio'), 40),
        borderColor: CorUtils.getCorPorNomeSp360('cinza-medio'),
        type: 'line',
        yAxisID: 'B',
        data: [],
        datalabels: {
          display: false,
        },
      }

      for (const key in dados) {
        if (dados.hasOwnProperty(key)) {
          labels.push(key)
          data.push(dados[key])
          aux += ((dados[key] * key / somatorio) * 100)
          integral.data.push(aux)

          let u = key / this.pontosCentrais.std
          uLabels[Math.floor(u)] = 'até ' + key
          if (isNaN(groupData[Math.floor(u)])) {
            groupData[Math.floor(u)] = 0
          }
          groupData[Math.floor(u)] = groupData[Math.floor(u)] + dados[key]
        }
      }

      let ctx = document.getElementById('bar-chart')
      let gradientStroke = ctx.getContext('2d').createLinearGradient(400, 0, 900, 0)
      let i = 0
      CorUtils.getSimpleVector().forEach(cor => {
        gradientStroke.addColorStop(i, cor)
        i += 0.5
      })

      let datasetStd = {
        label: 'distribuição da demanda',
        data: groupData,
        xAxisID: 'Std',
        backgroundColor: CorUtils.getGradientVector().slice(1),
        borderColor: CorUtils.getGradientVector().slice(1),
      }

      let dataset = {
        label: 'Distribuição da demanda',
        data: data,
        backgroundColor: gradientStroke,
        borderColor: gradientStroke,
      }

      this.histogramChart = {
        labels: labels,
        datasets: [integral, dataset],
      }

      this.histogramChartOption = {
        tooltips: {
          enabled: true,
          mode: 'index',
          intersect: true,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              label += Math.round(tooltipItem.yLabel * 100) / 100
              return label
            },
          },
        },
        elements: {
          point: {
            radius: 0.3,
          },
        },
        annotation: {
          events: ['click'],
          annotations: [
          ],
        },
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => MethGlob.thousandSeparator(value),
            anchor: 'end',
            // rotation: -90,
            align: 'end',
            display: 'true',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
        scales: {
          yAxes: [
            {
              id: 'A',
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'Numero de unidades no agrupamento',
              },
              ticks: {
                callback: function (value, index, values) {
                  return MethGlob.thousandSeparator(value)
                },
              },
            },
            {
              id: 'B',
              position: 'right',
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: 'Percentual Acumulado',
              },
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return value + '%'
                },
              },
            }],

          xAxes: [{
            id: 'X',
            barPercentage: 1,
            categoryPercentage: 1,
            gridLines: {
              display: false,
            },
            scaleLabel: {
              autoSkip: false,
              display: true,
              labelString: 'Numero de solicitações de Vagas',
            },
          }],
        },
      }
    },

    filtarGrafico () {

    },
  },
}
</script>

<style lang="scss" scoped>

.legenda {
  width: 100%;
  height: 100%;
  display: flex;
}

.widget.chart-widget {
  .widget-body {
    height: 550px;
  }
}

.wrapperMobPrinc {
  width: 40%;
  height: 40%;
  float: right;
  position: absolute;
}

.componente {
  margin-right: 10px;
}

.va-scrollbar {
  position: relative;
  height: 400px;

  .scrollbar-wrapper {
    box-shadow: none;
  }
}

.divTransparente {
  z-index: 10;
  position: absolute;
  top: 0;
  left: 70%;
  height: 60%;
  width: 30%;
  background: rgba(0, 0, 0, 0.75);
  border-radius: 25px;
  min-height: 480px;
  max-height: 480px;
}

.divColapsada {
  z-index: 10;
  position: absolute;
  top: 0;
  left: 70%;
  height: 7%;
  width: 30%;
  background: rgba(0, 0, 0, 0.75);
  border-radius: 25px;
  min-height: 60px;
}

.textDivInfo {
  color: white;
  margin: 10px 10px 10px 10px;
}

#tituloMob {
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 20px;
  margin-top: 20px;
}

.tituloProgress {
  margin-top: 10px;
}

@media (min-width: 1275px) and (max-width: 1500px) {
  .va-scrollbar {
    position: relative;
    height: 430px;

  }

  .divTransparente {
    z-index: 10;
    position: absolute;
    top: 0;
    left: 70%;
    height: 100%;
    width: 30%;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 25px;
  }

  .divColapsada {
    z-index: 10;
    position: absolute;
    top: 0;
    left: 70%;
    height: 7%;
    width: 30%;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 25px;
  }

  #tituloMob {
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
    margin-bottom: 5px;
    margin-top: 5px;
  }

}

@media (max-width: 1274px) {
  .divTransparente {
    z-index: 10;
    position: relative;
    bottom: 0;
    background: none;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .divColapsada {
    text-align: center;
    z-index: 10;
    position: relative;
    background: none;
    top: 0;
    left: 70%;
    height: 10px;
    width: 30%;
  }

  #tituloMob {
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
    margin-bottom: 20px;
    margin-top: 5px;
  }

  .textDivInfo {
    color: black;
    margin: 10px 10px 10px 10px;
  }

  .tituloProgress {
    margin-top: 10px;
  }
}

</style>
